<!-- eslint-disable max-len -->
<!--
3.1.Status do acervo – relatório simples
3.2.Status do acervo – relatório descritivo
3.3.Produtividade | relatório simples
3.4.Produtividade | relatório descritivo
3.7.Data do documento – relatório simples
3.8.Data do documento – relatório descritivo
3.9.Tipo de documental
3.11.Palavras-chave – relatório simples
3.12.Palavras-chave – relatório descritivo
3.18.Consulta
-->
<template>
  <div>
    <view-title>
      <v-icon
        class="primary--text mr-4"
        v-if="$vuetify.breakpoint.smAndUp"
      >fas fa-chart-bar</v-icon> {{ report }}
      <template slot="button">
        <v-col class="text-right">
          <v-menu
            offset-y
            max-height="500"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                rounded
                color="primary"
                class="font-weight-normal"
                v-on="on"
              >
                Selecionar relatório
                <v-icon
                  class="ml-2"
                  x-small
                >
                  fas fa-caret-down
                </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group>
                <v-subheader>STATUS DO ACERVO</v-subheader>
                <v-list-item
                  ripple
                  @click="selectReport('Status do Acervo - Relatório Simples')"
                >
                  <v-list-item-title>Relatório Simples</v-list-item-title>
                </v-list-item>
                <v-list-item
                  ripple
                  @click="selectReport('Status do Acervo - Relatório Descritivo')"
                >
                  <v-list-item-title>Relatório Descritivo</v-list-item-title>
                </v-list-item>
                <div v-if="isAdmin">
                  <v-subheader>PRODUTIVIDADE</v-subheader>
                  <v-list-item @click="selectReport('Produtividade - Relatório Simples')">
                    <v-list-item-title>Relatório Simples</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="selectReport('Produtividade - Relatório Descritivo')">
                    <v-list-item-title>Relatório Descritivo</v-list-item-title>
                  </v-list-item>
                </div>
                <div>
                  <v-subheader>DATA DO DOCUMENTO</v-subheader>
                  <v-list-item @click="selectReport('Data do Documento - Relatório Simples')">
                    <v-list-item-title>Relatório Simples</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="selectReport('Data do Documento - Relatório Descritivo')">
                    <v-list-item-title>Relatório Descritivo</v-list-item-title>
                  </v-list-item>
                </div>
                <div>
                  <v-subheader>ESPÉCIE DOCUMENTAL/TIPO DE OBJETO</v-subheader>
                  <v-list-item @click="selectReport('Espécie Documental/Tipo de Objeto')">
                    <v-list-item-title>Espécie Documental/Tipo de Objeto</v-list-item-title>
                  </v-list-item>
                </div>
                <div>
                  <v-subheader>PALAVRAS-CHAVE</v-subheader>
                  <v-list-item @click="selectReport('Palavras-chave - Relatório Simples')">
                    <v-list-item-title>Relatório Simples</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="selectReport('Palavras-chave - Relatório Descritivo')">
                    <v-list-item-title>Relatório Descritivo</v-list-item-title>
                  </v-list-item>
                </div>
                <div>
                  <v-subheader>CONSULTA</v-subheader>
                  <v-list-item @click="selectReport('Consulta')">
                    <v-list-item-title>Consulta</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-col>
      </template>
    </view-title>
    <v-container fluid>
      <v-row
        class="mx-5"
        v-if="report === 'Relatórios'"
      >
        <v-col>
          <p>Selecione o tipo de relatório que deseja extrair do sistema.</p>
        </v-col>
      </v-row>
      <report-filters-collection-status
        v-if="report === 'Status do Acervo - Relatório Simples' || report === 'Status do Acervo - Relatório Descritivo'"
        :on-filter="onFilter"
        :report="report"
        :tipo-publicacoes="tipoPublicacoes"
        :segmentos="segmentos"
        :generate-report="generateReport"
        :filter="filter"
      />
      <report-filters-productivity
        v-if="report === 'Produtividade - Relatório Simples' || report === 'Produtividade - Relatório Descritivo'"
        :on-filter="onFilter"
        :report="report"
        :tipo-publicacoes="tipoPublicacoes"
        :segmentos="segmentos"
        :generate-report="generateReport"
        :accounts="accounts"
        :filter="filter"
      />
      <report-filters-documental
        v-if="report === 'Espécie Documental/Tipo de Objeto'"
        :on-filter="onFilter"
        :report="report"
        :tipo-publicacoes="tipoPublicacoes"
        :segmentos="segmentos"
        :generate-report="generateReport"
        :tipos-objeto="tiposObjeto"
        :filter="filter"
      />
      <report-filters-key-words
        v-if="report === 'Palavras-chave - Relatório Simples' || report === 'Palavras-chave - Relatório Descritivo'"
        :on-filter="onFilter"
        :report="report"
        :tipo-publicacoes="tipoPublicacoes"
        :segmentos="segmentos"
        :generate-report="generateReport"
        :search-keywords="searchKeywords"
        :palavraschave="palavraschave"
        :filter="filter"
      />
      <report-filters-document-date
        v-if="report === 'Data do Documento - Relatório Simples' || report === 'Data do Documento - Relatório Descritivo'"
        :on-filter="onFilter"
        :report="report"
        :tipo-publicacoes="tipoPublicacoes"
        :segmentos="segmentos"
        :generate-report="generateReport"
        :search-keywords="searchKeywords"
        :palavraschave="palavraschave"
        :filter="filter"
      />
      <report-filters-search
        v-if="report === 'Consulta'"
        :on-filter="onFilter"
        :report="report"
        :tipo-publicacoes="tipoPublicacoes"
        :segmentos="segmentos"
        :generate-report="generateReport"
        :filter="filter"
      />
      <div id="report">
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import viewTitle from '@/components/view-title.vue';
import reportFiltersCollectionStatus from '@/components/report-filters-collection-status.vue';
import reportFiltersProductivity from '@/components/report-filters-productivity.vue';
import reportFiltersKeyWords from '@/components/report-filters-key-words.vue';
import reportFiltersDocumentDate from '@/components/report-filters-document-date.vue';
import reportFiltersDocumental from '@/components/report-filters-documental.vue';
import reportFiltersSearch from '@/components/report-filters-search.vue';

export default {
  components: {
    viewTitle,
    reportFiltersCollectionStatus,
    reportFiltersProductivity,
    reportFiltersKeyWords,
    reportFiltersDocumental,
    reportFiltersDocumentDate,
    reportFiltersSearch,
  },
  data() {
    return {
      report: 'Relatórios',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    next();
  },
  computed: {
    ...mapGetters('views/reports', [
      'isAdmin',
      'tipoPublicacoes',
      'segmentos',
      'accounts',
      'palavraschave',
      'tiposObjeto',
      'filter',
    ]),
  },
  methods: {
    selectReport(report) {
      this.report = report;
      this.setFilter({});
    },
    ...mapActions('views/reports', [
      'onFilter',
      'afterRouteUpdate',
      'generateReport',
      'setFilter',
      'searchKeywords',
    ]),
  },
};
</script>
